import { Button } from "react-bootstrap";
import { Toolbar } from "@bagel-web/components";

import TextFilterControl from "../TextFilterControl";

// The store's controls: the shared key and value text filters, plus in edit
// mode the button adding a top-level node.
const KVStoreToolbar = ({
  keyFilterId,
  valueFilterId,
  isEditMode,
  onAdd,
}: {
  keyFilterId?: string;
  valueFilterId?: string;
  isEditMode?: boolean;
  onAdd: () => void;
}) => (
  <Toolbar className="mb-3">
    <TextFilterControl
      placeholder="Filter by key..."
      componentId={keyFilterId}
    />
    <TextFilterControl
      placeholder="Filter by value..."
      componentId={valueFilterId}
    />
    {isEditMode && (
      <Button
        variant="secondary"
        className="text-nowrap"
        onClick={onAdd}
        data-testid="kv-store-add-root"
      >
        <i className="bi-plus-lg me-1" />
        Item
      </Button>
    )}
  </Toolbar>
);

export default KVStoreToolbar;
